// react
import classNames from "classnames";
import { useState, useEffect } from "react";
// icons
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";

const Pagination = (props) => {
  const { total, changePage, limit, currentPage, setCurrentPage } = props;

  // Set number of pages
  const numberOfPages = [];
  // console.log(currentPage)
  for (let counter = 1; counter <= Math.ceil(total / limit); counter++) {
    numberOfPages.push(counter);
  }

  // Current active button number

  // Array of buttons what we see on the page
  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  useEffect(() => {
    let tempNumberOfPages = [...arrOfCurrButtons];

    let dotsInitial = "...";
    let dotsLeft = "... ";
    let dotsRight = " ...";

    if (numberOfPages.length < 6) {
      tempNumberOfPages = numberOfPages;
    } else if (currentPage >= 1 && currentPage <= 3) {
      setCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
    } else if (currentPage === 4) {
      const sliced = numberOfPages.slice(0, 5);
      tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
    } else if (currentPage > 4 && currentPage < numberOfPages.length - 2) {
      // from 5 to 8 -> (10 - 2)
      const sliced1 = numberOfPages.slice(currentPage - 2, currentPage); // sliced1 (5-2, 5) -> [4,5]
      const sliced2 = numberOfPages.slice(currentPage, currentPage + 1); // sliced1 (5, 5+1) -> [6]
      tempNumberOfPages = [
        1,
        dotsLeft,
        ...sliced1,
        ...sliced2,
        dotsRight,
        numberOfPages.length,
      ]; // [1, '...', 4, 5, 6, '...', 10]
    } else if (currentPage > numberOfPages.length - 3) {
      // > 7
      const sliced = numberOfPages.slice(numberOfPages.length - 4); // slice(10-4)
      tempNumberOfPages = [1, dotsLeft, ...sliced];
    } else if (currentPage === dotsInitial) {
      setCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentPage === dotsRight) {
      setCurrentPage(arrOfCurrButtons[3] + 2);
    } else if (currentPage === dotsLeft) {
      setCurrentPage(arrOfCurrButtons[3] - 2);
    }

    setArrOfCurrButtons(tempNumberOfPages);
    changePage(currentPage);
    // eslint-disable-next-line
  }, [currentPage]);

  return (
    <ul className="flex justify-center items-center w-full">
      <li
        className="cursor-pointer border w-8 h-8 flex justify-center items-center rounded-full hover:bg-dark-blue hover:text-white mx-0.5"
        onClick={() => setCurrentPage((prev) => (prev <= 1 ? prev : prev - 1))}
        disabled={currentPage === 1}
      >
        <MdOutlineNavigateBefore />
      </li>

      {arrOfCurrButtons.map((item, index) => {
        return (
          <li
            key={index}
            className={classNames(
              "cursor-pointer border w-8 h-8 flex justify-center items-center rounded-full hover:bg-dark-blue hover:text-white mx-0.5",
              {
                "bg-dark-blue text-white": currentPage === item,
              }
            )}
            onClick={() => {
              if (item === "...") {
                setCurrentPage(
                  arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1
                );
              } else if (item === " ...") {
                setCurrentPage(arrOfCurrButtons[3] + 2);
              } else if (item === "... ") {
                setCurrentPage(arrOfCurrButtons[3] - 2);
              } else {
                setCurrentPage(item);
              }
            }}
          >
            {item}
          </li>
        );
      })}

      <li
        className="cursor-pointer border w-8 h-8 flex justify-center items-center rounded-full hover:bg-dark-blue hover:text-white mx-0.5"
        disabled={currentPage === numberOfPages.length}
        role="button"
        onClick={() =>
          setCurrentPage((prev) =>
            prev >= numberOfPages.length ? prev : prev + 1
          )
        }
      >
        <MdOutlineNavigateNext />
      </li>
    </ul>
  );
};

export default Pagination;
